import { fetchDeviceLogs, changePage } from '#action/device/log';
import { deviceLogFilterServiceOptions } from '#service/autocomplete-service/option';
import {
  ProjectsFilterOptionService,
  DevicesFilterOptionService,
  UserFilterOptionService,
  ActionTypeFilterOptionService
} from '#service/autocomplete-service/service';
import { uuidv4 } from '#helper';

const projectComponent = {
  type: 'SelectWithCounter',
  name: 'project',
  label: 'Project',
  relatedTo: 'device-log',
  id: uuidv4(),
  fetchOptionsService: ProjectsFilterOptionService,
  searchFields: ['title']
};

const deviceComponent = {
  type: 'SelectWithCounter',
  name: 'device',
  label: 'Device',
  relatedTo: 'device-log',
  id: uuidv4(),
  fetchOptionsService: DevicesFilterOptionService,
  searchFields: ['title']
};

const filterUserComponent = {
  type: 'SelectWithCounter',
  name: 'user',
  label: 'Actor',
  relatedTo: 'device-log',
  id: uuidv4(),
  fetchOptionsService: UserFilterOptionService,
  searchFields: ['fullName']
};

const actionTypeSelect = {
  type: 'SelectWithCounter',
  name: 'event',
  label: 'Action',
  relatedTo: 'device-log',
  id: uuidv4(),
  fetchOptionsService: ActionTypeFilterOptionService,
  optionServiceConfig: deviceLogFilterServiceOptions,
  searchFields: ['label']
};

const filterConfig = {
  disableSync: true,
  customActions: {
    fetchFilterData: fetchDeviceLogs,
    changePage
  },
  dateRangeComponent: true,
  components: [projectComponent, deviceComponent, filterUserComponent, actionTypeSelect]
};

export default filterConfig;
